import {useState} from 'react';

import type {PreviewStreamController, UserMediaStatus} from '@pexip/media';
import type {DeviceError} from '../types';

import {
    useDeviceErrorMessage,
    useSubscribeToInputError,
} from './useDeviceErrorMessage';

export const usePreviewErrorHandling = (
    controller: PreviewStreamController,
    streamStatus: UserMediaStatus,
    requested: {audio: boolean; video: boolean},
) => {
    const [videoInputError, setVideoInputError] = useState<DeviceError>({
        title: '',
    });
    const [audioInputError, setAudioInputError] = useState<DeviceError>({
        title: '',
    });
    const {videoError, audioError} = useDeviceErrorMessage({
        streamStatus,
        requested,
    });

    useSubscribeToInputError(
        setAudioInputError,
        setVideoInputError,
        controller,
    );

    return {
        videoInputError: videoInputError.title ? videoInputError : videoError,
        setVideoInputError,
        audioInputError: audioInputError.title ? audioInputError : audioError,
        setAudioInputError,
    };
};
